export class TimeDuration {
    public static readonly showUpdateAppVersionMsg = 10000;
    public static readonly periodicCallForCheckVersionUpdate = 120000;
}